import { defineMessages } from 'react-intl';

import SpacingEdit from './SpacingEdit';
import SpacingView from './SpacingView';

import verticalSvg from '@plone/volto/icons/vertical.svg';

defineMessages({
  spacing: {
    id: 'Spacing',
    defaultMessage: 'Spacing',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.spacingLine = {
    id: 'spacingLine',
    title: 'Spacing',
    group: 'layout',
    icon: verticalSvg,
    view: SpacingView,
    edit: SpacingEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
